// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ========================================
   Playout Tour - Premium Theme (Refined)
   Refined Shape & Animations (Micro Compact)
   Forces Global Overrides
   ======================================== */

/* Main Container - Floating Card Effect */
body .playout-tour-v2.shepherd-element {
    background: #ffffff !important;
    border: 1px solid rgba(0, 0, 0, 0.05) !important;
    border-radius: 12px !important;
    /* Smaller radius */
    box-shadow: 0 10px 30px -5px rgba(0, 0, 0, 0.15) !important;
    max-width: 280px !important;
    /* Micro width */
    padding: 0 !important;
    overflow: hidden !important;
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif !important;
    width: 100% !important;
    z-index: 10000 !important;
    opacity: 1 !important;
    visibility: visible !important;
    transform: translateY(0) !important;
    transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1) !important;
}

/* Ensure focus outline is removed */
body .playout-tour-v2.shepherd-element:focus {
    outline: none !important;
}

/* Header Section - Clean */
body .playout-tour-v2 .shepherd-header {
    background: transparent !important;
    border-bottom: none !important;
    padding: 12px 14px 0 14px !important;
    border-top-left-radius: 12px !important;
    border-top-right-radius: 12px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: flex-end !important;
    min-height: auto !important;
}

body .playout-tour-v2 .shepherd-cancel-icon {
    color: #cbd5e1 !important;
    cursor: pointer !important;
    font-size: 1rem !important;
    font-weight: 400 !important;
    transition: color 0.2s !important;
    margin: 0 !important;
    padding: 2px !important;
}

body .playout-tour-v2 .shepherd-cancel-icon:hover {
    color: #64748b !important;
}

/* Content Text - Crisp/Small */
body .playout-tour-v2 .shepherd-text {
    padding: 4px 14px 12px 14px !important;
    color: #4b5563 !important;
    font-size: 12.5px !important;
    line-height: 1.45 !important;
    background: transparent !important;
}

/* Custom Title */
body .playout-tour-v2 .playout-tour-title {
    font-size: 15px !important;
    font-weight: 700 !important;
    color: #1e293b !important;
    line-height: 1.2 !important;
    letter-spacing: -0.01em !important;
    margin-top: 2px !important;
    margin-bottom: 6px !important;
}

/* Progress Indicators - Bottom Right */
body .playout-tour-v2 .tour-footer-indicators {
    display: flex !important;
    align-items: center !important;
    justify-content: flex-end !important;
    /* Right aligned */
    gap: 8px !important;
    margin-top: 10px !important;
    margin-bottom: -2px !important;
    width: 100% !important;
}

body .playout-tour-v2 .playout-tour-progress {
    display: flex !important;
    align-items: center !important;
}

body .playout-tour-v2 .dots-container {
    display: flex !important;
    gap: 3px !important;
}

body .playout-tour-v2 .progress-dot {
    width: 4px !important;
    height: 4px !important;
    border-radius: 50% !important;
    background: #e2e8f0 !important;
    transition: all 0.3s ease !important;
}

body .playout-tour-v2 .progress-dot.active {
    background: #3b82f6 !important;
    width: 16px !important;
    border-radius: 6px !important;
}

body .playout-tour-v2 .progress-dot.completed {
    background: #93c5fd !important;
}

/* Bottom Right Step Counter */
body .playout-tour-v2 .tour-step-counter-bottom {
    font-size: 9.5px !important;
    color: #94a3b8 !important;
    font-weight: 600 !important;
    letter-spacing: 0.05em !important;
    text-transform: uppercase !important;
}

/* Inner Content Styling */
body .playout-tour-v2 .playout-tour-content p {
    margin: 0 !important;
    color: #475569 !important;
}

body .playout-tour-v2 .playout-tour-content strong {
    color: #2563eb !important;
    font-weight: 700 !important;
}

/* Tip Box - Glass-like Subtle */
/* Removed tip icon/box styles (unused now) */

/* Footer & Buttons */
body .playout-tour-v2 .shepherd-footer {
    background: transparent !important;
    padding: 0 14px 14px 14px !important;
    display: flex !important;
    justify-content: space-between !important;
    align-items: center !important;
    border-top: none !important;
    border-bottom-left-radius: 12px !important;
    border-bottom-right-radius: 12px !important;
}

body .playout-tour-v2 .shepherd-button {
    border-radius: 8px !important;
    padding: 6px 14px !important;
    font-size: 12px !important;
    font-weight: 600 !important;
    cursor: pointer !important;
    transition: all 0.2s !important;
    border: 1px solid transparent !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    margin: 0 !important;
}

body .playout-tour-v2 .shepherd-button:active {
    transform: scale(0.97) !important;
}

/* Counter in Footer (Text Look) */
body .playout-tour-v2 .playout-tour-counter-btn {
    background: transparent !important;
    border: none !important;
    box-shadow: none !important;
    padding: 0 !important;
    margin-right: auto !important;
    /* Push other buttons to the right */
    pointer-events: none !important;
}

body .playout-tour-v2 .tour-step-counter {
    color: #94a3b8 !important;
    font-size: 13px !important;
    font-weight: 600 !important;
    font-variant-numeric: tabular-nums !important;
}

/* Primary Action */
body .playout-tour-v2 .playout-btn-primary {
    background: #2563eb !important;
    /* Flat blue used instead of gradient for cleaner micro look */
    color: #ffffff !important;
    box-shadow: 0 2px 5px rgba(37, 99, 235, 0.2) !important;
    min-width: 60px !important;
}

body .playout-tour-v2 .playout-btn-primary:hover {
    background: #1d4ed8 !important;
}

/* Secondary Action */
body .playout-tour-v2 .playout-btn-secondary {
    background: #ffffff !important;
    color: #64748b !important;
    border-color: #e2e8f0 !important;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05) !important;
}

body .playout-tour-v2 .playout-btn-secondary:hover {
    background: #f8fafc !important;
    color: #0f172a !important;
    border-color: #cbd5e1 !important;
}

/* Skip Action */
body .playout-tour-v2 .playout-btn-skip {
    background: transparent !important;
    color: #94a3b8 !important;
    padding: 4px 8px !important;
    font-size: 11px !important;
    font-weight: 600 !important;
    border: none !important;
    box-shadow: none !important;
}

body .playout-tour-v2 .playout-btn-skip:hover {
    color: #64748b !important;
}

/* Disabled State */
body .playout-tour-v2 .shepherd-button.disabled {
    opacity: 0.5 !important;
    cursor: default !important;
    pointer-events: none !important;
    box-shadow: none !important;
    background: #f1f5f9 !important;
    color: #cbd5e1 !important;
}

/* Arrow Decoration */
body .playout-tour-v2 .shepherd-arrow,
body .playout-tour-v2 .shepherd-arrow::before {
    display: none !important;
    /* Cleaner look without arrows, floating */
}

/* HIGHLIGHT FIXES */
/* Darker overlay to make target pop more, but remove blur to avoid visual artifacts on modals */
.shepherd-modal-overlay-container {
    opacity: 0.5 !important;
    background-color: #000 !important;
    backdrop-filter: none !important;
    /* Removed blur */
    z-index: 998 !important;
    /* Lower than typical modals (1050+) */
}

/* Tour Card should be highest, but coexist with interactions */
body .playout-tour-v2.shepherd-element {
    z-index: 999 !important;
    /* Below Modals (1050), Above Overlay (998) */
}

/* Force target element above overlay - Fix: Remove background override to keep original button color */
.shepherd-target.shepherd-enabled {
    z-index: 1000 !important;
    /* Just above Tour Element (999) */
    position: relative !important;
    pointer-events: auto !important;
    /* transition: box-shadow 0.3s ease !important; -- Removed to prevent glitches */
    box-shadow: 0 0 0 4px #3b82f6, 0 0 25px rgba(59, 130, 246, 0.6) !important;
    /* Enhanced Glow */
    border-radius: 4px !important;
}

/* ========================================
   Animation - Hand Gesture & Highlights
   ======================================== */

@keyframes tour-hand-bounce-up {

    0%,
    100% {
        transform: translateY(0);
    }

    50% {
        transform: translateY(-12px);
    }
}

@keyframes tour-circle-pulse {
    0% {
        box-shadow: 0 0 0 0 rgba(37, 99, 235, 0.7);
    }

    70% {
        box-shadow: 0 0 0 15px rgba(37, 99, 235, 0);
    }

    100% {
        box-shadow: 0 0 0 0 rgba(37, 99, 235, 0);
    }
}

.tour-hand-gesture {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: 16px;
    padding: 16px;
    border-radius: 12px;
    background: #f0f9ff;
    border: 1px dashed #bae6fd;
}

.tour-hand-icon {
    font-size: 32px;
    margin-bottom: 6px;
    animation: tour-hand-bounce-up 1.5s infinite ease-in-out;
    filter: drop-shadow(0 4px 6px rgba(0, 0, 0, 0.1));
}

.tour-hand-text {
    font-size: 11px;
    color: #0284c7;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.05em;
}

/* Trigger Button Styles */
.playout-tour-trigger {
    height: 38px !important;
    display: inline-flex !important;
    align-items: center !important;
    gap: 8px !important;
    background: #ffffff !important;
    border: 1px solid #e2e8f0 !important;
    color: #475569 !important;
    padding: 0 16px !important;
    border-radius: 10px !important;
    font-size: 13px !important;
    font-weight: 600 !important;
    cursor: pointer !important;
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05) !important;
}

.playout-tour-trigger:hover {
    background: #f8fafc !important;
    border-color: #3b82f6 !important;
    color: #2563eb !important;
    transform: translateY(-2px) !important;
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1) !important;
}

.playout-tour-trigger .tour-icon {
    font-size: 18px !important;
    color: #3b82f6 !important;
}`, "",{"version":3,"sources":["webpack://./src/components/Tour/playout-tour-theme.css"],"names":[],"mappings":"AAAA;;;;6CAI6C;;AAE7C,0CAA0C;AAC1C;IACI,8BAA8B;IAC9B,gDAAgD;IAChD,8BAA8B;IAC9B,mBAAmB;IACnB,2DAA2D;IAC3D,2BAA2B;IAC3B,gBAAgB;IAChB,qBAAqB;IACrB,2BAA2B;IAC3B,oHAAoH;IACpH,sBAAsB;IACtB,yBAAyB;IACzB,qBAAqB;IACrB,8BAA8B;IAC9B,mCAAmC;IACnC,gEAAgE;AACpE;;AAEA,oCAAoC;AACpC;IACI,wBAAwB;AAC5B;;AAEA,2BAA2B;AAC3B;IACI,kCAAkC;IAClC,8BAA8B;IAC9B,oCAAoC;IACpC,uCAAuC;IACvC,wCAAwC;IACxC,wBAAwB;IACxB,8BAA8B;IAC9B,oCAAoC;IACpC,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;IAC1B,0BAA0B;IAC1B,2BAA2B;IAC3B,iCAAiC;IACjC,oBAAoB;IACpB,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,+BAA+B;AAC/B;IACI,sCAAsC;IACtC,yBAAyB;IACzB,4BAA4B;IAC5B,4BAA4B;IAC5B,kCAAkC;AACtC;;AAEA,iBAAiB;AACjB;IACI,0BAA0B;IAC1B,2BAA2B;IAC3B,yBAAyB;IACzB,2BAA2B;IAC3B,kCAAkC;IAClC,0BAA0B;IAC1B,6BAA6B;AACjC;;AAEA,uCAAuC;AACvC;IACI,wBAAwB;IACxB,8BAA8B;IAC9B,oCAAoC;IACpC,kBAAkB;IAClB,mBAAmB;IACnB,2BAA2B;IAC3B,8BAA8B;IAC9B,sBAAsB;AAC1B;;AAEA;IACI,wBAAwB;IACxB,8BAA8B;AAClC;;AAEA;IACI,wBAAwB;IACxB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,6BAA6B;IAC7B,8BAA8B;IAC9B,oCAAoC;AACxC;;AAEA;IACI,8BAA8B;IAC9B,sBAAsB;IACtB,6BAA6B;AACjC;;AAEA;IACI,8BAA8B;AAClC;;AAEA,8BAA8B;AAC9B;IACI,2BAA2B;IAC3B,yBAAyB;IACzB,2BAA2B;IAC3B,iCAAiC;IACjC,oCAAoC;AACxC;;AAEA,0BAA0B;AAC1B;IACI,oBAAoB;IACpB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA,gCAAgC;AAChC,6CAA6C;;AAE7C,qBAAqB;AACrB;IACI,kCAAkC;IAClC,oCAAoC;IACpC,wBAAwB;IACxB,yCAAyC;IACzC,8BAA8B;IAC9B,2BAA2B;IAC3B,0CAA0C;IAC1C,2CAA2C;AAC/C;;AAEA;IACI,6BAA6B;IAC7B,4BAA4B;IAC5B,0BAA0B;IAC1B,2BAA2B;IAC3B,0BAA0B;IAC1B,+BAA+B;IAC/B,wCAAwC;IACxC,+BAA+B;IAC/B,8BAA8B;IAC9B,kCAAkC;IAClC,oBAAoB;AACxB;;AAEA;IACI,iCAAiC;AACrC;;AAEA,kCAAkC;AAClC;IACI,kCAAkC;IAClC,uBAAuB;IACvB,2BAA2B;IAC3B,qBAAqB;IACrB,6BAA6B;IAC7B,oCAAoC;IACpC,+BAA+B;AACnC;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;IAC1B,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA,mBAAmB;AACnB;IACI,8BAA8B;IAC9B,8DAA8D;IAC9D,yBAAyB;IACzB,uDAAuD;IACvD,0BAA0B;AAC9B;;AAEA;IACI,8BAA8B;AAClC;;AAEA,qBAAqB;AACrB;IACI,8BAA8B;IAC9B,yBAAyB;IACzB,gCAAgC;IAChC,oDAAoD;AACxD;;AAEA;IACI,8BAA8B;IAC9B,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA,gBAAgB;AAChB;IACI,kCAAkC;IAClC,yBAAyB;IACzB,2BAA2B;IAC3B,0BAA0B;IAC1B,2BAA2B;IAC3B,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,mBAAmB;AACnB;IACI,uBAAuB;IACvB,0BAA0B;IAC1B,+BAA+B;IAC/B,2BAA2B;IAC3B,8BAA8B;IAC9B,yBAAyB;AAC7B;;AAEA,qBAAqB;AACrB;;IAEI,wBAAwB;IACxB,0CAA0C;AAC9C;;AAEA,oBAAoB;AACpB,gGAAgG;AAChG;IACI,uBAAuB;IACvB,iCAAiC;IACjC,gCAAgC;IAChC,iBAAiB;IACjB,uBAAuB;IACvB,sCAAsC;AAC1C;;AAEA,+DAA+D;AAC/D;IACI,uBAAuB;IACvB,6CAA6C;AACjD;;AAEA,uGAAuG;AACvG;IACI,wBAAwB;IACxB,kCAAkC;IAClC,6BAA6B;IAC7B,+BAA+B;IAC/B,gFAAgF;IAChF,0EAA0E;IAC1E,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;;6CAE6C;;AAE7C;;IAEI;;QAEI,wBAAwB;IAC5B;;IAEA;QACI,4BAA4B;IAChC;AACJ;;AAEA;IACI;QACI,0CAA0C;IAC9C;;IAEA;QACI,2CAA2C;IAC/C;;IAEA;QACI,wCAAwC;IAC5C;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,wDAAwD;IACxD,iDAAiD;AACrD;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA,0BAA0B;AAC1B;IACI,uBAAuB;IACvB,+BAA+B;IAC/B,8BAA8B;IAC9B,mBAAmB;IACnB,8BAA8B;IAC9B,oCAAoC;IACpC,yBAAyB;IACzB,0BAA0B;IAC1B,8BAA8B;IAC9B,0BAA0B;IAC1B,2BAA2B;IAC3B,0BAA0B;IAC1B,4DAA4D;IAC5D,oDAAoD;AACxD;;AAEA;IACI,8BAA8B;IAC9B,gCAAgC;IAChC,yBAAyB;IACzB,sCAAsC;IACtC,0DAA0D;AAC9D;;AAEA;IACI,0BAA0B;IAC1B,yBAAyB;AAC7B","sourcesContent":["/* ========================================\n   Playout Tour - Premium Theme (Refined)\n   Refined Shape & Animations (Micro Compact)\n   Forces Global Overrides\n   ======================================== */\n\n/* Main Container - Floating Card Effect */\nbody .playout-tour-v2.shepherd-element {\n    background: #ffffff !important;\n    border: 1px solid rgba(0, 0, 0, 0.05) !important;\n    border-radius: 12px !important;\n    /* Smaller radius */\n    box-shadow: 0 10px 30px -5px rgba(0, 0, 0, 0.15) !important;\n    max-width: 280px !important;\n    /* Micro width */\n    padding: 0 !important;\n    overflow: hidden !important;\n    font-family: 'Inter', -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif !important;\n    width: 100% !important;\n    z-index: 10000 !important;\n    opacity: 1 !important;\n    visibility: visible !important;\n    transform: translateY(0) !important;\n    transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1) !important;\n}\n\n/* Ensure focus outline is removed */\nbody .playout-tour-v2.shepherd-element:focus {\n    outline: none !important;\n}\n\n/* Header Section - Clean */\nbody .playout-tour-v2 .shepherd-header {\n    background: transparent !important;\n    border-bottom: none !important;\n    padding: 12px 14px 0 14px !important;\n    border-top-left-radius: 12px !important;\n    border-top-right-radius: 12px !important;\n    display: flex !important;\n    align-items: center !important;\n    justify-content: flex-end !important;\n    min-height: auto !important;\n}\n\nbody .playout-tour-v2 .shepherd-cancel-icon {\n    color: #cbd5e1 !important;\n    cursor: pointer !important;\n    font-size: 1rem !important;\n    font-weight: 400 !important;\n    transition: color 0.2s !important;\n    margin: 0 !important;\n    padding: 2px !important;\n}\n\nbody .playout-tour-v2 .shepherd-cancel-icon:hover {\n    color: #64748b !important;\n}\n\n/* Content Text - Crisp/Small */\nbody .playout-tour-v2 .shepherd-text {\n    padding: 4px 14px 12px 14px !important;\n    color: #4b5563 !important;\n    font-size: 12.5px !important;\n    line-height: 1.45 !important;\n    background: transparent !important;\n}\n\n/* Custom Title */\nbody .playout-tour-v2 .playout-tour-title {\n    font-size: 15px !important;\n    font-weight: 700 !important;\n    color: #1e293b !important;\n    line-height: 1.2 !important;\n    letter-spacing: -0.01em !important;\n    margin-top: 2px !important;\n    margin-bottom: 6px !important;\n}\n\n/* Progress Indicators - Bottom Right */\nbody .playout-tour-v2 .tour-footer-indicators {\n    display: flex !important;\n    align-items: center !important;\n    justify-content: flex-end !important;\n    /* Right aligned */\n    gap: 8px !important;\n    margin-top: 10px !important;\n    margin-bottom: -2px !important;\n    width: 100% !important;\n}\n\nbody .playout-tour-v2 .playout-tour-progress {\n    display: flex !important;\n    align-items: center !important;\n}\n\nbody .playout-tour-v2 .dots-container {\n    display: flex !important;\n    gap: 3px !important;\n}\n\nbody .playout-tour-v2 .progress-dot {\n    width: 4px !important;\n    height: 4px !important;\n    border-radius: 50% !important;\n    background: #e2e8f0 !important;\n    transition: all 0.3s ease !important;\n}\n\nbody .playout-tour-v2 .progress-dot.active {\n    background: #3b82f6 !important;\n    width: 16px !important;\n    border-radius: 6px !important;\n}\n\nbody .playout-tour-v2 .progress-dot.completed {\n    background: #93c5fd !important;\n}\n\n/* Bottom Right Step Counter */\nbody .playout-tour-v2 .tour-step-counter-bottom {\n    font-size: 9.5px !important;\n    color: #94a3b8 !important;\n    font-weight: 600 !important;\n    letter-spacing: 0.05em !important;\n    text-transform: uppercase !important;\n}\n\n/* Inner Content Styling */\nbody .playout-tour-v2 .playout-tour-content p {\n    margin: 0 !important;\n    color: #475569 !important;\n}\n\nbody .playout-tour-v2 .playout-tour-content strong {\n    color: #2563eb !important;\n    font-weight: 700 !important;\n}\n\n/* Tip Box - Glass-like Subtle */\n/* Removed tip icon/box styles (unused now) */\n\n/* Footer & Buttons */\nbody .playout-tour-v2 .shepherd-footer {\n    background: transparent !important;\n    padding: 0 14px 14px 14px !important;\n    display: flex !important;\n    justify-content: space-between !important;\n    align-items: center !important;\n    border-top: none !important;\n    border-bottom-left-radius: 12px !important;\n    border-bottom-right-radius: 12px !important;\n}\n\nbody .playout-tour-v2 .shepherd-button {\n    border-radius: 8px !important;\n    padding: 6px 14px !important;\n    font-size: 12px !important;\n    font-weight: 600 !important;\n    cursor: pointer !important;\n    transition: all 0.2s !important;\n    border: 1px solid transparent !important;\n    display: inline-flex !important;\n    align-items: center !important;\n    justify-content: center !important;\n    margin: 0 !important;\n}\n\nbody .playout-tour-v2 .shepherd-button:active {\n    transform: scale(0.97) !important;\n}\n\n/* Counter in Footer (Text Look) */\nbody .playout-tour-v2 .playout-tour-counter-btn {\n    background: transparent !important;\n    border: none !important;\n    box-shadow: none !important;\n    padding: 0 !important;\n    margin-right: auto !important;\n    /* Push other buttons to the right */\n    pointer-events: none !important;\n}\n\nbody .playout-tour-v2 .tour-step-counter {\n    color: #94a3b8 !important;\n    font-size: 13px !important;\n    font-weight: 600 !important;\n    font-variant-numeric: tabular-nums !important;\n}\n\n/* Primary Action */\nbody .playout-tour-v2 .playout-btn-primary {\n    background: #2563eb !important;\n    /* Flat blue used instead of gradient for cleaner micro look */\n    color: #ffffff !important;\n    box-shadow: 0 2px 5px rgba(37, 99, 235, 0.2) !important;\n    min-width: 60px !important;\n}\n\nbody .playout-tour-v2 .playout-btn-primary:hover {\n    background: #1d4ed8 !important;\n}\n\n/* Secondary Action */\nbody .playout-tour-v2 .playout-btn-secondary {\n    background: #ffffff !important;\n    color: #64748b !important;\n    border-color: #e2e8f0 !important;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05) !important;\n}\n\nbody .playout-tour-v2 .playout-btn-secondary:hover {\n    background: #f8fafc !important;\n    color: #0f172a !important;\n    border-color: #cbd5e1 !important;\n}\n\n/* Skip Action */\nbody .playout-tour-v2 .playout-btn-skip {\n    background: transparent !important;\n    color: #94a3b8 !important;\n    padding: 4px 8px !important;\n    font-size: 11px !important;\n    font-weight: 600 !important;\n    border: none !important;\n    box-shadow: none !important;\n}\n\nbody .playout-tour-v2 .playout-btn-skip:hover {\n    color: #64748b !important;\n}\n\n/* Disabled State */\nbody .playout-tour-v2 .shepherd-button.disabled {\n    opacity: 0.5 !important;\n    cursor: default !important;\n    pointer-events: none !important;\n    box-shadow: none !important;\n    background: #f1f5f9 !important;\n    color: #cbd5e1 !important;\n}\n\n/* Arrow Decoration */\nbody .playout-tour-v2 .shepherd-arrow,\nbody .playout-tour-v2 .shepherd-arrow::before {\n    display: none !important;\n    /* Cleaner look without arrows, floating */\n}\n\n/* HIGHLIGHT FIXES */\n/* Darker overlay to make target pop more, but remove blur to avoid visual artifacts on modals */\n.shepherd-modal-overlay-container {\n    opacity: 0.5 !important;\n    background-color: #000 !important;\n    backdrop-filter: none !important;\n    /* Removed blur */\n    z-index: 998 !important;\n    /* Lower than typical modals (1050+) */\n}\n\n/* Tour Card should be highest, but coexist with interactions */\nbody .playout-tour-v2.shepherd-element {\n    z-index: 999 !important;\n    /* Below Modals (1050), Above Overlay (998) */\n}\n\n/* Force target element above overlay - Fix: Remove background override to keep original button color */\n.shepherd-target.shepherd-enabled {\n    z-index: 1000 !important;\n    /* Just above Tour Element (999) */\n    position: relative !important;\n    pointer-events: auto !important;\n    /* transition: box-shadow 0.3s ease !important; -- Removed to prevent glitches */\n    box-shadow: 0 0 0 4px #3b82f6, 0 0 25px rgba(59, 130, 246, 0.6) !important;\n    /* Enhanced Glow */\n    border-radius: 4px !important;\n}\n\n/* ========================================\n   Animation - Hand Gesture & Highlights\n   ======================================== */\n\n@keyframes tour-hand-bounce-up {\n\n    0%,\n    100% {\n        transform: translateY(0);\n    }\n\n    50% {\n        transform: translateY(-12px);\n    }\n}\n\n@keyframes tour-circle-pulse {\n    0% {\n        box-shadow: 0 0 0 0 rgba(37, 99, 235, 0.7);\n    }\n\n    70% {\n        box-shadow: 0 0 0 15px rgba(37, 99, 235, 0);\n    }\n\n    100% {\n        box-shadow: 0 0 0 0 rgba(37, 99, 235, 0);\n    }\n}\n\n.tour-hand-gesture {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    margin-top: 16px;\n    padding: 16px;\n    border-radius: 12px;\n    background: #f0f9ff;\n    border: 1px dashed #bae6fd;\n}\n\n.tour-hand-icon {\n    font-size: 32px;\n    margin-bottom: 6px;\n    animation: tour-hand-bounce-up 1.5s infinite ease-in-out;\n    filter: drop-shadow(0 4px 6px rgba(0, 0, 0, 0.1));\n}\n\n.tour-hand-text {\n    font-size: 11px;\n    color: #0284c7;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n}\n\n/* Trigger Button Styles */\n.playout-tour-trigger {\n    height: 38px !important;\n    display: inline-flex !important;\n    align-items: center !important;\n    gap: 8px !important;\n    background: #ffffff !important;\n    border: 1px solid #e2e8f0 !important;\n    color: #475569 !important;\n    padding: 0 16px !important;\n    border-radius: 10px !important;\n    font-size: 13px !important;\n    font-weight: 600 !important;\n    cursor: pointer !important;\n    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05) !important;\n}\n\n.playout-tour-trigger:hover {\n    background: #f8fafc !important;\n    border-color: #3b82f6 !important;\n    color: #2563eb !important;\n    transform: translateY(-2px) !important;\n    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1) !important;\n}\n\n.playout-tour-trigger .tour-icon {\n    font-size: 18px !important;\n    color: #3b82f6 !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
